import PropTypes from "prop-types";
import { TabBarFinal } from "./tab-bar-final.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired
};
TabBarFinal.propTypes = propTypes;
export {
  TabBarFinal
};
